export const hiddenChapters = [
  "DisclaimerChapter",
  "CoverPageChapter",
  "ContentChapter"
];

export const ReportType = {
  DIGITAL: 'digital',
  GENERIC: 'generic',
};

export const ManualScoringVersion = {
  RAW: 'raw',
  NORMALIZED: 'normalized',
}

export const ScoreTypeLabelMap = {
  percentile: 'Percentile',
  percentCorrect: 'Percent Correct',
  sten: 'Sten',
  'Ai-based': 'Ai-based',
  Evaluator: 'Evaluator',
}

export const ScoreRepresentationType = {
  STIVE: 'stive',
}